/**
* Countries Drop Down 0.0.1 - jQuery plugin to load Drop Down with Countries from JSon and Cascade to States Drop down
*
* By Robbie Chiha <Robert.Chiha@vii.com.au>
* Requires: jQuery 1.3 or newer
*
*
*/
(function ($) {
    $.countriesDropDown = {
        countriesData: [],
        findCountriesByCode: $.noop
    };
    var loading = false;
    $.fn.countriesDropDown = function (options) {
        return this.each(function () {
            var defaults = {
                defaultText: 'Please select',
                statesDropDownId: 'StateDropDown',
                statesFoundSelector: '.show-if-states-found',
                statesNotFoundSelector: '.hide-if-states-found',
                jsonFile: "countries.json",
                defaultValue: "",
                defaultStateValue: "",
                onCreate: $.noop,
                //onChange(Country Control, bool whether states are found)
                onChange: $.noop
            };

            //initial variables
            var opts = $.extend(defaults, options);
            var $input = $(this);

            var stateDD = $('#' + opts.statesDropDownId).get(0);

            $(this).data('options', options);

            var loadCountries = function (callback) {
                if (loading) {
                    setTimeout(function () {
                        loadCountries(callback)
                    }, 500);
                    return;
                }
                loading = true;
                if (!$.countriesDropDown.countriesData.length) {
                    $.getJSON(opts.jsonFile, function (data) {
                        $.countriesDropDown.countriesData = data;
                        loading = false;
                        if ($.isFunction(callback))
                            callback();
                    }
                    );
                }
                else {
                    loading = false;
                    callback();
                }
            },
                getObjects = function (obj, key, val) {
                    var objects = [];
                    for (var i in obj) {
                        if (!obj.hasOwnProperty(i)) continue;
                        if (typeof obj[i] == 'object') {
                            objects = objects.concat(getObjects(obj[i], key, val));
                        } else if (i == key && obj[key] == val) {
                            objects.push(obj);
                        }
                    }
                    return objects;
                },
                findCountriesByCode = function (value, callback) {

                    loadCountries(function () {
                        var selectedCountries = getObjects($.countriesDropDown.countriesData, "CountryCode", value);
                        if (callback && selectedCountries && selectedCountries.length > 0)
                            callback(selectedCountries[0]);
                    });
                },
                changeCountry = function () {
                    var selectedCountry = $input.val();
                    findCountriesByCode(selectedCountry, function (countryObj) {
                        if (countryObj && countryObj.States && countryObj.States.length) {
                            $(opts.statesFoundSelector).show().removeAttr("disabled");
                            $(opts.statesNotFoundSelector).hide().attr("disabled", true);

                            var selected = $(stateDD).val();
                            if (!selected)
                                selected = opts.defaultStateValue;
                            $(stateDD).empty();
                            $.each(countryObj.States, function (k, state) {
                                $(stateDD).append($('<option>', {
                                    value: state.StateCode,
                                    text: state.Name
                                }));
                            } );

                            $(stateDD).val(selected);
                           
                            opts.onChange($input, true);
                          
                            $(stateDD).focus();
                        }
                        else {
                            $(opts.statesFoundSelector).hide().attr("disabled", true);
                            $(opts.statesNotFoundSelector).show().removeAttr("disabled");
                            opts.onChange($input, false);
                        }
                    })
                };

            $.countriesDropDown.findCountriesByCode = findCountriesByCode;

            loadCountries(function () {

                if (opts.defaultValue) {
                    $input.val(opts.defaultValue);

                }

                changeCountry();
                opts.onCreate($input);
            });

            $input.on("change", function () {
                changeCountry();
            });
        });

    }
}
)(jQuery);